import { Injectable } from "@angular/core";
import { CoreHttpClient } from "@obg/ngx.core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { CallingCodeConfigService } from "./calling-code.config";
import { CallingCode, CallingCodeState, GetCallingCodeResponse } from "./calling-code.model";

@Injectable({
	providedIn: "root",
})
export class CallingCodeService {
	constructor(
		private httpClient: CoreHttpClient,
		private config: CallingCodeConfigService
	) {}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(ContentValue.getCallingCodes)" instead
	 */
	getCallingCodes(): Observable<CallingCodeState> {
		return this.httpClient.get<GetCallingCodeResponse>({ url: this.config.getCallingCodesEndpoint() }).pipe(
			map((response) => ({
				singleMarketCallingCodes: this.getUniqueCountryCallingCodes(response.callingCodes),
				singleMarketCallingCodesWithCountryCode: response.callingCodes,
			}))
		);
	}

	private getUniqueCountryCallingCodes(callingCodes: CallingCode[]): string[] {
		return [...new Set(callingCodes.map((x) => x.countryCallingCode))];
	}
}
